import LoginForm from "./_form";

const Login = () => {
  return (
    <div className="w-100 h-100 flex-column d-flex align-items-center justify-content-center">
      <h1>Login</h1>
      <LoginForm />
    </div>
  );
};

export default Login;
